import { __decorate, __extends } from "tslib";
import { body } from "@pnp/odata";
import { _GraphQueryableCollection, _GraphQueryableInstance, graphInvokableFactory } from "../graphqueryable.js";
import { defaultPath, getById } from "../decorators.js";
import { graphDelete, graphPost } from "../operations.js";
/**
 * Member
 */
var _Member = /** @class */ (function (_super) {
    __extends(_Member, _super);
    function _Member() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Removes this Member
     */
    _Member.prototype.remove = function () {
        return graphDelete(this.clone(Member, "$ref"));
    };
    return _Member;
}(_GraphQueryableInstance));
export { _Member };
export var Member = graphInvokableFactory(_Member);
/**
 * Members
 */
var _Members = /** @class */ (function (_super) {
    __extends(_Members, _super);
    function _Members() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Use this API to add a member to an Office 365 group, a security group or a mail-enabled security group through
     * the members navigation property. You can add users or other groups.
     * Important: You can add only users to Office 365 groups.
     *
     * @param id Full @odata.id of the directoryObject, user, or group object you want to add (ex: `https://graph.microsoft.com/v1.0/directoryObjects/${id}`)
     */
    _Members.prototype.add = function (id) {
        return graphPost(this.clone(Members, "$ref"), body({ "@odata.id": id }));
    };
    _Members = __decorate([
        defaultPath("members"),
        getById(Member)
    ], _Members);
    return _Members;
}(_GraphQueryableCollection));
export { _Members };
export var Members = graphInvokableFactory(_Members);
//# sourceMappingURL=types.js.map